import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  getBody,
  getCarState,
  getEngines,
  getGeneration,
  getLoading,
  getModels,
} from "../../../../../redux/selectors";
import {
  getCar,
  getCarDetail,
  getEngine,
  getGenerations,
  getModel,
} from "../../../../../redux/reducers";
import { useNavigate } from "react-router-dom";

const initialValues: any = {
  procedure: "",
};

const Search = () => {
  const navigate = useNavigate();

  const cars = useAppSelector((state) => getCarState(state));
  const models = useAppSelector((state) => getModels(state));
  const engine = useAppSelector((state) => getEngines(state));
  const body = useAppSelector((state) => getBody(state));
  const generation = useAppSelector((state) => getGeneration(state));

  const loading = useAppSelector((state) => getLoading(state));

  const [engineId, setEngineId] = useState("");

  const dispatch = useAppDispatch();
  const onSubmit = (value: any) => {
    console.log(value);
  };
  const { handleSubmit, setFieldValue, values } = useFormik({
    initialValues: initialValues,
    onSubmit,
  });
  const [step, setStep] = useState<number>(1);

  const objLength = Object.keys(values).length;

  useEffect(() => {
    if (objLength != 1) {
      setStep(objLength + 1);
    } else {
    }
  }, [values]);

  const submit = () => {
    if (objLength == 1) {
      setStep(objLength + 1);
    }
    handleSubmit();
  };


  return (
    <div className={styles.search}>
      <div className="container">
        <h2 style={{ opacity: loading ? 1 : 0 }}>Загрузка данных</h2>
      </div>
      <div className={`${styles.container} container`}>
        <Form>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Select
                disabled={step < 1 || loading}
                onChange={(value: any) => {
                  submit();
                  setFieldValue("procedure", value.target.value);
                  // @ts-ignore
                  dispatch(getCar(value.target.value));
                }}
                value={values.procedure}
              >
                <option>Марка авто</option>
                {cars.length &&
                  cars.map((el): any => (
                    <option value={el.carId}>{el.carName}</option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Select
                disabled={step < 2 || loading}
                onChange={(value: any) => {
                  setFieldValue("model", value.target.value);
                  submit();
                  // @ts-ignore
                  dispatch(getModel(value.target.value));
                }}
                value={values.model}
              >
                <option>Модель авто</option>
                {models.length &&
                  models.map((el: any) => (
                    <option value={el.carModelId}>{el.carModelName}</option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Select
                disabled={step < 3 || loading}
                onChange={(value: any) => {
                  setFieldValue("generation", value.target.value);
                  submit();
                  // @ts-ignore
                  dispatch(getGenerations(value.target.value));
                }}
                value={values.generation}
              >
                <option>Покаление авто</option>
                {generation.length &&
                  generation.map((el: any) => (
                    <option value={el.generationId}>{el.generationName}</option>
                  ))}
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Select
                disabled={step < 4 || loading}
                onChange={(value: any) => {
                  setFieldValue("bodyView", value.target.value);
                  submit();
                  // @ts-ignore
                  dispatch(getEngine(value.target.value));
                }}
                value={values.bodyView}
              >
                <option>Вид кузова</option>
                {body.length &&
                  body.map((el: any): any => (
                    <option value={el.bodyId}>{el.bodyName}</option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Select
                disabled={step < 5 || loading}
                onChange={(value: any) => {
                  setFieldValue("engine", value.target.value);
                  submit();
                  setEngineId(value.target.value);
                }}
                value={values.engine}
              >
                <option>Двигатель</option>
                {engine.length &&
                  engine.map((el: any): any => (
                    <option value={el.engineId}>{el.engineName}</option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={4}>
              <Button
                className={step > 5 ? "" : styles.disabled}
                onClick={(e) => {
                  e.preventDefault();
                  // @ts-ignore
                  dispatch(getCarDetail(engineId));
                  navigate("/search");
                }}
              >
                Найти
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default Search;
